// actions/auth.actions.js

import axiosInstance from "../helpers/axios";
import { authConstants } from "./constants";

// Send OTP
export const sendLoginOtp = (email) => {
  return (dispatch) => {
    dispatch({ type: authConstants.SEND_OTP_REQUEST });
    return axiosInstance
      .post("/login/sendOtp", { email })
      .then(() => {
        dispatch({ type: authConstants.SEND_OTP_SUCCESS });
      })
      .catch((err) => {
        dispatch({
          type: authConstants.SEND_OTP_FAILURE,
          payload: { error: err.response?.data?.message || "Failed to send OTP" },
        });
        return Promise.reject(err);
      });
  };
};

// Verify OTP
export const verifyLoginOtp = ({ email, otp }) => {
  return (dispatch) => {
    dispatch({ type: authConstants.VERIFY_OTP_REQUEST });
    return axiosInstance
      .post("/login/verifyOtp", { email, otp })
      .then(({ data }) => {
        const { token, user } = data;
        if (!token || !user) throw new Error("Invalid login response. Please update the API server and try again.");
        localStorage.setItem("authToken", token);
        localStorage.removeItem("token");
        localStorage.setItem("user", JSON.stringify(user));
        dispatch({
          type: authConstants.VERIFY_OTP_SUCCESS,
          payload: { authToken: token, user },
        });
      })
      .catch((err) => {
        dispatch({
          type: authConstants.VERIFY_OTP_FAILURE,
          payload: { error: err.response?.data?.message || err.message || "OTP verification failed" },
        });
        return Promise.reject(err);
      });
  };
};


// export const AdminSignIn = (user) => {
//   return async (dispatch) => {
//     dispatch({ type: authConstants.LOGIN_REQUEST });

//     try {
//       const res = await axiosInstance.post(`/signin`, { ...user });

//       if (res && res.data) {
//         const { token, user } = res.data;

//         localStorage.setItem("authToken", token);
//         localStorage.setItem("user", JSON.stringify(user));

//         dispatch({
//           type: authConstants.LOGIN_SUCCESS,
//           payload: {
//             authToken: token,
//             user: user,
//           },
//         });
//       } else {
//         dispatch({
//           type: authConstants.LOGIN_FAILURE,
//           payload: { error: "Invalid response from server" },
//         });
//       }
//     } catch (error) {
//       console.log("Error in sig in", error);
//       dispatch({
//         type: authConstants.LOGIN_FAILURE,
//         payload: { error: error.response?.data?.message || "Unknown error" },
//       });
//     }
//   };
// };

export const isUserLoggedIn = () => async (dispatch) => {
  const token = localStorage.getItem("authToken");
  if (!token) {
    localStorage.removeItem("user");
    dispatch({ type: authConstants.LOGOUT_SUCCESS });
    return;
  }
  try {
    const { data } = await axiosInstance.get("/session/me", { memberRequest: true, timeout: 10000 });
    localStorage.setItem("user", JSON.stringify(data.user));
    dispatch({ type: authConstants.VERIFY_OTP_SUCCESS, payload: { authToken: token, user: data.user } });
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("user");
      dispatch({ type: authConstants.LOGOUT_SUCCESS });
    }
    throw error;
  }
};

export const signout = () => async (dispatch) => {
  ["authToken", "token", "user", "selectedComponent"].forEach(key => localStorage.removeItem(key));
  dispatch({ type: authConstants.LOGOUT_SUCCESS });
};
